import { useNavigate } from 'react-router-dom';
import PublicNavbar from '../components/PublicNavbar';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />

      <div className="max-w-4xl mx-auto px-6 pt-28 pb-12 sm:pt-36 sm:pb-20">
        <div className="prose prose-lg max-w-none">
          <h2 className="text-4xl font-black text-[#1B4332] mb-6" style={{ fontFamily: 'Nunito, sans-serif' }}>Terms & Conditions</h2>
          <p className="text-[#1B4332]/80 mb-8">Last updated: {new Date().toLocaleDateString()}</p>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>1. Acceptance of Terms</h3>
            <p className="text-[#1B4332]/80 mb-4">
              By accessing and using PurrCheck, you accept and agree to be bound by the terms and provisions of this agreement.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>2. Service Description</h3>
            <p className="text-[#1B4332]/80 mb-4">
              PurrCheck is an AI-powered educational tool designed to help cat owners understand cat food ingredients and receive behavior guidance. 
              <strong className="text-primary"> PurrCheck is NOT a substitute for professional veterinary advice, diagnosis, or treatment.</strong>
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>3. Educational Tool Disclaimer</h3>
            <div className="bg-orange-50 border-2 border-orange-200 rounded-2xl p-6 mb-4">
              <p className="text-[#1B4332] font-bold mb-2">IMPORTANT DISCLAIMER</p>
              <p className="text-[#1B4332]/80">
                PurrCheck provides educational information only and should not be considered veterinary medical advice. 
                Always consult with a licensed veterinarian regarding your cat's health, diet, and behavior. 
                PurrCheck assumes no liability for any decisions made based on information provided through our service.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>4. Subscription Terms</h3>
            <p className="text-[#1B4332]/80 mb-4"><strong>Free Plan:</strong></p>
            <ul className="list-disc pl-6 text-[#1B4332]/80 space-y-2 mb-4">
              <li>3 ingredient scans per month</li>
              <li>5 behavior chat questions per month</li>
              <li>No credit card required</li>
            </ul>
            <p className="text-[#1B4332]/80 mb-4"><strong>Premium Monthly ($8.99/month):</strong></p>
            <ul className="list-disc pl-6 text-[#1B4332]/80 space-y-2 mb-4">
              <li>Unlimited ingredient scans</li>
              <li>Unlimited behavior chat</li>
              <li>Cancel anytime</li>
              <li>Billed monthly</li>
            </ul>
            <p className="text-[#1B4332]/80 mb-4"><strong>Premium Yearly ($79.99/year - Save 25%):</strong></p>
            <ul className="list-disc pl-6 text-[#1B4332]/80 space-y-2">
              <li>All Premium features</li>
              <li>Billed annually</li>
              <li>Save $28 per year</li>
            </ul>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>5. Payment & Billing</h3>
            <p className="text-[#1B4332]/80 mb-4">
              Premium subscriptions are billed automatically on a recurring basis. You may cancel your subscription at any time through your account settings. 
              Cancellation takes effect at the end of the current billing period.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>6. Refund Policy</h3>
            <p className="text-[#1B4332]/80 mb-4">
              We offer a 7-day money-back guarantee for first-time premium subscribers. For complete details, please see our <a href="/refund-policy" className="text-primary hover:underline">Refund Policy</a>.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>7. User Responsibilities</h3>
            <p className="text-[#1B4332]/80 mb-4">You agree to:</p>
            <ul className="list-disc pl-6 text-[#1B4332]/80 space-y-2">
              <li>Provide accurate information</li>
              <li>Maintain the security of your account</li>
              <li>Use the service lawfully and appropriately</li>
              <li>Not share your account credentials</li>
              <li>Not attempt to reverse engineer or exploit the service</li>
            </ul>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>8. Limitation of Liability</h3>
            <p className="text-[#1B4332]/80 mb-4">
              PurrCheck is provided "as is" without warranties of any kind. We are not liable for any damages arising from the use or inability to use our service.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>9. Changes to Terms</h3>
            <p className="text-[#1B4332]/80 mb-4">
              We reserve the right to modify these terms at any time. Continued use of the service after changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>10. Contact</h3>
            <p className="text-[#1B4332]/80">
              For questions about these terms, contact us at: <a href="mailto:support@purrcheck.com" className="text-primary hover:underline">support@purrcheck.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;